export default __webpack_public_path__ + "static/media/Button_Disclosure_Down.4f610346.svg";